import { trackStructEvent } from "@snowplow/browser-tracker";
import { ONEPASS_CATEGORY } from "@analytics/consts";
import { OnePassUpsellModalAction } from "@analytics/types";

export function emitUpsellModalImpression(
  action: OnePassUpsellModalAction = "Upsell Modal"
) {
  trackStructEvent({
    category: ONEPASS_CATEGORY,
    action: action,
    label: "Impression",
  });
}
